import * as Yup from "yup";


export const ModuleSchema = Yup.object({
    module: Yup.string().required(" Enter Module Name"),
    description: Yup.string().required(" Enter Description "),
    cstatus: Yup.string().required(" Select Single Action"),
    icon: Yup.string().required("Select Icon"),
    priority: Yup.string().required("Enter Priority"),
    status: Yup.string().required(" Select Status"),
});